import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=b10aede0&scoped=true&"
import script from "./PermissionsEditor.vue?vue&type=script&lang=ts&"
export * from "./PermissionsEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=b10aede0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10aede0",
  null
  
)

export default component.exports